"use client";

import Link from "next/link";
import React from "react";
import { useAuth } from "../auth/SessionWrapper";
import Spinner from "../Spinner";

export default function WelcomeScreen() {
  const { loading, user } = useAuth();

  if (loading || !user) {
    return <Spinner />;
  }

  return (
    <div className={"text-center space-y-9 max-w-full min-h-0 py-3 mx-auto"}>
      <h2
        className="text-xl md:text-4xl 
      font-bold break-words break-all"
      >
        {`Olá, ${user.name}!`}
      </h2>
      <h2
        className="text-xl md:text-4xl
       font-bold"
      >
        Bem vindo ao Mapeador de Conhecimentos!{" "}
      </h2>
      <p
        className="
      text-base md:text-2xl
      "
      >
        Para acessar o formulário, clique no botão abaixo:
      </p>
      <div className="h-fit w-fit mx-auto mt-16 font-bold text-c-bg">
        <Link href={"/formulario"}>
          <div className="py-3 px-16 rounded-md bg-c-secondary text-lg md:text-2xl">
            Formulário
          </div>
        </Link>
      </div>
    </div>
  );
}
